export default {"src":"/_next/static/media/notification.2426c265.svg","height":37,"width":36,"blurWidth":0,"blurHeight":0};